(() => {
  const closeAll = (except) => {
    document.querySelectorAll('[data-ja-share-root]').forEach(root => {
      if (root === except) return;
      const menu = root.querySelector('[data-ja-share-menu]');
      const trigger = root.querySelector('[data-ja-share-open]');
      if (menu) menu.hidden = true;
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
    });
  };

  const setupLinks = (root) => {
    const trigger = root.querySelector('[data-ja-share-open]');
    if (!trigger) return;
    const title = trigger.dataset.productTitle || document.title;
    const url = trigger.dataset.productUrl || window.location.href;
    const message = `Take a look at ${title}: ${url}`;
    const wa = root.querySelector('[data-ja-share-whatsapp]');
    const email = root.querySelector('[data-ja-share-email]');
    if (wa) wa.href = `https://wa.me/?text=${encodeURIComponent(message)}`;
    if (email) email.href = `mailto:?subject=${encodeURIComponent(title)}&body=${encodeURIComponent(message)}`;
  };

  document.addEventListener('click', async (event) => {
    const trigger = event.target.closest('[data-ja-share-open]');
    if (trigger) {
      event.preventDefault();
      const root = trigger.closest('[data-ja-share-root]');
      const menu = root?.querySelector('[data-ja-share-menu]');
      if (!root || !menu) return;
      setupLinks(root);
      const willOpen = menu.hidden;
      closeAll(root);
      menu.hidden = !willOpen;
      trigger.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      return;
    }

    const copy = event.target.closest('[data-ja-share-copy]');
    if (copy) {
      event.preventDefault();
      const root = copy.closest('[data-ja-share-root]');
      const trigger = root?.querySelector('[data-ja-share-open]');
      const status = root?.querySelector('[data-ja-share-status]');
      const url = trigger?.dataset.productUrl || window.location.href;
      try {
        await navigator.clipboard.writeText(url);
        if (status) status.textContent = 'Link copied';
      } catch (_) {
        if (status) status.textContent = 'Copy failed';
      }
      return;
    }

    if (!event.target.closest('[data-ja-share-root]')) closeAll();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeAll();
  });
})();
